import { Tablet, LifeBuoy } from 'lucide-react';
import { PORTAL_BRAND } from '../../data/brand';

/**
 * Shown instead of the pairing screen when `/pad` is opened somewhere that may
 * not pair a device — i.e. a normal browser rather than the Banepad kiosk app
 * (see canPairBanepadDevice). Pads that are ALREADY paired keep working; this
 * only closes the door on binding a new device from the open web.
 */
export function BanepadDeviceAppOnly() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-bg-soft text-center">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-3 text-ink-2">
          <Tablet size={40} />
        </div>
        <h1 className="font-display text-2xl font-bold text-ink mb-2">Åpne i Banepad-appen</h1>
        <p className="text-ink-2" style={{ fontSize: 15 }}>
          Et nettbrett kobles til en bane fra {PORTAL_BRAND.name} Banepad-appen, ikke fra
          nettleseren. Appen installeres på klubbens nettbrett av IT.
        </p>
        <p className="text-ink-3 mt-4 inline-flex items-center gap-2" style={{ fontSize: 13 }}>
          <LifeBuoy size={15} /> Kontakt {PORTAL_BRAND.name} support
        </p>
      </div>
    </div>
  );
}
